import { render, staticRenderFns } from "./HomeSticky.vue?vue&type=template&id=7dbd58c8&scoped=true"
import script from "./HomeSticky.vue?vue&type=script&lang=js"
export * from "./HomeSticky.vue?vue&type=script&lang=js"
import style0 from "./HomeSticky.vue?vue&type=style&index=0&id=7dbd58c8&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd58c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dbd58c8')) {
      api.createRecord('7dbd58c8', component.options)
    } else {
      api.reload('7dbd58c8', component.options)
    }
    module.hot.accept("./HomeSticky.vue?vue&type=template&id=7dbd58c8&scoped=true", function () {
      api.rerender('7dbd58c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/userCard/HomeSticky.vue"
export default component.exports